import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { retrieve, save } from "../../helpers/StorageHelper";

export default function SignUp2() {
  const navigate = useNavigate();
  const [full_name, setName] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if there is a name saved in localStorage and set it
    const savedName = retrieve("full_name");
    if (savedName) {
      setName(savedName);
    }
  }, []);

  useEffect(() => {
    setIsButtonDisabled(full_name.trim() === "");
  }, [full_name]);

  const handleNext = () => {
    if (!full_name.trim()) return;
    save("full_name", full_name);
    setIsLoading(true);
    navigate("/signup/profile");
  };
  return (
    <div className="onboarding-container">
      <div className="onboard-content">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="progress-container">
            <div className="step active stepactive" data-step="1"></div>
            <div className="progress-line active" data-line="1"></div>
            <div className="step" data-step="2"></div>
            <div className="progress-line" data-line="2"></div>
            <div className="step" data-step="3"></div>
            <div className="progress-line" data-line="3"></div>
            <div className="step" data-step="4"></div>
          </div>
          <h1
            style={{
              marginBottom: "40px",
              textAlign: "center",
              color: "rgba(230, 236, 241, 1)",
              fontFamily: "Poppins",
              fontSize: "20px",
              lineHeight: "30px",
              fontWeight: 600,
            }}
          >
            Add your name<span style={{ marginLeft: "12px" }}>1 / 4</span>
          </h1>
          <div className="d-flex flex-column align-items-center w-100 padding-card">
            <div className="textfield-1 input-fields password-container w-100">
              <input
                type="text"
                id="typenameInput"
                className="text-body-b2 w-100"
                placeholder=" "
                autoComplete="off"
                value={full_name}
                onChange={(e) => setName(e.target.value)}
              />
              <label htmlFor="typenameInput" className="text-body-b2">
                Enter name
              </label>
            </div>
            {error && (
              <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
            )}

            <div
              className="d-flex flex-column flex-sm-row gap-3 gap-sm-4 terms-buttons align-items-center w-100"
              style={{
                maxWidth: "345px",
                marginTop: "40px",
                marginBottom: "212px",
              }}
            >
              <button
                onClick={() => navigate("/")}
                className="btn-1 btn-1-basic"
                style={{ maxWidth: "160px", width: "100%" }}
              >
                Back
              </button>

              <button
                onClick={handleNext}
                id="nextButton"
                className="signup-next-btn"
                style={{
                  maxWidth: "160px",
                  width: "100%",
                  backgroundColor:
                    isButtonDisabled || isLoading
                      ? "rgba(153, 209, 255, 1)"
                      : "rgba(0, 140, 255, 1)",
                  cursor:
                    isButtonDisabled || isLoading ? "not-allowed" : "pointer",
                }}
                disabled={isButtonDisabled || isLoading}
              >
                {isLoading ? "Loading..." : "Next"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
